import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';
import { Division } from '~/apis/ssf';
import { useSortableTable } from '~/hooks/useSortableTable';

interface Props {
  divisions: Division[];
  isLoading: boolean;
}

function Row({ division }: { division: Division }) {
  return (
    <Table.Row>
      <Table.Col>
        <Link to={`${division.id}`}>{`${division.name} - ${division.series.name}`}</Link>
      </Table.Col>
      <Table.Col>{division.series.competition_type.description}</Table.Col>
      <Table.Col>{division.series.year}</Table.Col>
    </Table.Row>
  );
}

export function DivisionsListTable({ divisions, isLoading }: Props) {
  const { register } = useSortableTable('name');

  return (
    <Table bg="even">
      <Table.Head>
        <Table.Row>
          <Table.Col {...register('name')} as="th">
            Namn
          </Table.Col>
          <Table.Col as="th">Tävlingstyp</Table.Col>
          <Table.Col as="th">År</Table.Col>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {isLoading ? <Table.Loading cols={3} /> : divisions.map(d => <Row division={d} key={d.id} />)}
      </Table.Body>
    </Table>
  );
}
